<template>
  <div class="header">
    <router-link to="/">
      <img class="logo" src="@/assets/images/JAW-Innovation-Group-Logo.png" alt="An image of JAW Innovation Group logo">
    </router-link>

    <nav class="nav-items" :class="{ 'open': isMenuOpen }">
      <ul>
        <li ><router-link class="nav-link" exact-active-class="active-link" to="/">HOME</router-link></li>
        <li><router-link class="nav-link" exact-active-class="active-link" to="/about">ABOUT</router-link></li>
        <li><router-link class="nav-link" exact-active-class="active-link" to="/clients">CLIENTS</router-link></li>
        <li><router-link class="nav-link" exact-active-class="active-link" to="/contact">CONTACT</router-link></li>
        <li><router-link class="nav-link" exact-active-class="active-link" to="/faq">FAQS</router-link></li>
      </ul>
    </nav>

    <!-- Burger Menu (visible on mobile) -->
    <div class="burger-icon" @click="toggleMenu">
      <img src="@/assets/burger.svg" alt="Menu" />
    </div>

    <transition name="menu-slide">
      <nav v-if="isMenuOpen" class="mobile-menu">
        <button class="close-icon" @click="toggleMenu" aria-label="Close menu">
        ✕
        </button>
        <ul>
          <li><router-link class="menu-link" @click="toggleMenu" exact-active-class="active-link" to="/">HOME</router-link></li>
          <li><router-link class="menu-link" @click="toggleMenu" exact-active-class="active-link" to="/about">ABOUT</router-link></li>
          <li><router-link class="menu-link" @click="toggleMenu" exact-active-class="active-link" to="/clients">CLIENTS</router-link></li>
          <li><router-link class="menu-link" @click="toggleMenu" exact-active-class="active-link" to="/contact">CONTACT</router-link></li>
          <li><router-link class="menu-link" @click="toggleMenu" exact-active-class="active-link" to="/faq">FAQS</router-link></li>
        </ul>
      </nav>
    </transition>

  </div>
</template>

<script setup>
import { ref } from 'vue'

const isMenuOpen = ref(false)

function toggleMenu() {
  isMenuOpen.value = !isMenuOpen.value
}
</script>

<style>
.header {
  width: 100%;
  height: 180px;
  background: #070923;
  display: flex;
  justify-content: space-around;
}

.logo {
  width: 251px;
  height: 82px;
  margin-top: 65px;
}

.nav-items {
  display: none;
}

.active-link {
  color: white;
}

.burger-icon {
  margin-top: 85px;
}

.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #101540;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;
  overflow-y: hidden; /* 🔐 scroll lock */
  touch-action: none;  /* optional: prevents weird iOS stuff */
}

.mobile-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-link {
  color: #00FF0C;
  font-weight: 500;
  font-size: 24px;
  font-family: "Oxanium-SemiBold", sans-serif;
  line-height: 35px;
  text-decoration: none;
  display: block;
  padding: 0.75rem 0;
  transition: color 0.2s ease;
}

.nav-link:hover {
  color: white;
}

/* Slide down transition */
.menu-slide-enter-active,
.menu-slide-leave-active {
  transition: all 0.3s ease;
}

.menu-slide-enter-from,
.menu-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.close-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 2rem;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1001;
}

/* sm: ≥ 640px - Larger phones / small tablets */
@media (min-width: 640px) {

}

/* md: ≥ 768px - Tablets / landscape phones */
@media (min-width: 768px) {
  .header {
    display: flex;
    justify-content: space-between;
  }

  .logo {
    width: 251px;
    height: 82px;
    margin-top: 65px;
    margin-left: 30px;
    cursor: pointer;
  }

  .nav-items {
    display: none;
  }

  .active-link {
    color: white;
  }

  .burger-icon {
    display: block;
    margin-right: 30px;
  }

}

/* lg: ≥ 1024px - Small laptops */
@media (min-width: 1024px) {
  .header {
    display: flex;
    justify-content: space-between;
  }

  .logo {
    width: 499px;
    height: 163px;
    margin-left: 50px;
  }

  .nav-items {
    display: block;
    margin-right: 50px;
    margin-top: 135px;
  }

  .active-link {
    color: white;
  }

  .nav-items ul {
    display: flex;
    margin: 0;
    padding: 0;
    gap: 2.5rem;
    list-style: none;
  }

  .nav-link {
    color: #00FF0C;
    font-weight: 500;
    font-size: 24px;
    font-family: Oxanium-SemiBold;
    line-height: 35px;
    text-decoration: none;
  }

  .burger-icon {
    display: none;
  }

  
}

/* xl: ≥ 1280px - Desktops */
@media (min-width: 1280px) {

}

/* 2xl: ≥ 1536px - Large screens / 4K monitors */
@media (min-width: 1536px) {
  .logo {
    width: 499px;
    height: 163px;
    margin-left: 122px;
  }

  .nav-items {
    margin-right: 132px;
  }

  .nav-items ul {
    gap: 95px;
  }

  .active-link {
    color: white;
  }
}
</style>